import React from "react";
import { makeStyles } from "@material-ui/styles";
import MUIDataTable from "mui-datatables";
import { Button } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
  table: {
    "& .MuiTableCell-body": {
      textAlign: "center",
      color: "black",
    },
    "& .MuiTableHead-root .MuiTableCell-head": {
      backgroundColor: "#01D4FF !important",
    },
  },
}));

export default function Tables(props) {
  const classes = useStyles();

  const downloadCsv = (baseName) => {
    const timestamp = new Date().toLocaleString().replace(/[\s,:/]/g, "-");
    const filename = `${baseName}_${timestamp}.csv`;
    return filename;
  };

  const addSerialNumbers = (data) => {
    return data.map((item, index) => {
      const serialNumber = index + 1;
      return { ...item, serialNumber };
    });
  };

  const handleDownloadCSV = () => {
    if (!props.data || props.data.length === 0) {
      return;
    }
    const now = new Date();
    const pad = n => n.toString().padStart(2, '0');
    const downloadDateTime = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    const infoRow = [`Downloaded at: ${downloadDateTime}`];
    const headers = [
      "Sr.No.",
      "Full Name",
      "Email",
      "Phone No.",
      "Created At",
      "State",
      "City",
      "Block",
      "Status"
    ];
    const csvData = props.data.map((user, index) => [
      index + 1,
      user.fullName || "",
      user.email || "",
      user.phoneNo ? `+${user.phoneNo}` : "NA",
      user.createTime ? new Date(user.createTime).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }) : "",
      user.state || "",
      user.city || "",
      user.block || "",
      user.userStatus || ""
    ]);
    const csvContent = [
      infoRow,
      headers,
      ...csvData
    ]
      .map(row => row.map(field => `"${field}"`).join(","))
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    const timestamp = new Date().toLocaleString().replace(/[\s,:/]/g, "-");
    const filename = `User_List_${timestamp}.csv`;
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const options = {
    textLabels: {
      body: {
        noMatch: "No Data Available",
      },
    },
    // searchOpen: true,
    filter: false, // Disable filtering
    download: false, // Disable CSV download
    downloadOptions: {
      filename: downloadCsv("data_export"),
      separator: ",",
    },
    print: false, // Disable printing
    viewColumns: false,
    search: false,
    // count:6, // Hide "View Columns" option
    selectableRows: "none",
    pagination: false,
    rowsPerPageOptions: props?.data?.length,
    responsive: "standard",
    customHeadLabelStyle: {
      textAlign: "center", // or "left" or "right" as desired
    },
    customToolbar: () => (
      <Button
        variant="contained"
        startIcon={<GetApp style={{ color: "white" }} />}
        onClick={handleDownloadCSV}
        style={{
          backgroundColor: "#00d4ff",
          color: "white",
          fontWeight: "bold",
          textTransform: "none",
          padding: "8px 16px",
          borderRadius: "4px",
          boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
          marginRight: "10px"
        }}
        disabled={!props.data || props.data.length === 0}
      >
        Download CSV
      </Button>
    ),
  };
  const dataWithSerialNumbers = props.data ? addSerialNumbers(props.data) : [];
  return (
    <>
        <MUIDataTable
        className={classes.table}
        data={dataWithSerialNumbers}
        columns={props.column}
        options={options}
      />
    </>
  );
}
